import { Box, Grid } from "@chakra-ui/react";
import { DurationInsightsPanelItem, StationsVisitedInsightsPanelItem, SummaryInsightsPanelItem } from "../insights/InsightsPanelDefinedItems";



export default function PublicProfilePanel({ statistics }) {


    return (
        <Box p={4} borderWidth="1px" borderRadius="lg">
            <Grid
                templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
                gap={6}
            >
                {/* 1x1 */}
                <SummaryInsightsPanelItem
                    noOfJourneys={statistics.noOfJourneys}
                    totalDistance={statistics.totalDistance}
                    averageDistance={statistics.averageDistance}
                    timesAroundTheWorld={statistics.timesAroundTheWorld}
                    timesToTheMoon={statistics.timesToTheMoon}
                />

                {/* 2x1 */}
                <DurationInsightsPanelItem
                    totalDuration={statistics.totalDuration}
                    averageDuration={statistics.averageDuration}
                    fullyFormattedDuration={statistics.fullyFormattedDuration}
                    isolatedMinutesDuration={statistics.isolatedMinutesDuration}
                    isolatedHoursDuration={statistics.isolatedHoursDuration}
                    isolatedDaysDuration={statistics.isolatedDaysDuration}
                    isolatedWeeksDuration={statistics.isolatedWeeksDuration}
                    isolatedMonthsDuration={statistics.isolatedMonthsDuration}
                />

                {/* 3x1 */}
                <StationsVisitedInsightsPanelItem
                    noOfStationsVisited={statistics.noOfStationsVisited}
                    topStations={statistics.topStations}
                />
            </Grid>
        </Box>
    )
}